import * as React from "react";

const CartWarning: React.FC = () => {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M6,1.25 L0,11.75 L12,11.75 L6,1.25 Z M6.5625,5 L6.5625,5.5625 L6.5625,8.1875 L6.5625,8.75 L5.4375,8.75 L5.4375,8.1875 L5.4375,5.5625 L5.4375,5 L6.5625,5 Z M5.4375,9.5 L6.5625,9.5 L6.5625,10.625 L5.4375,10.625 L5.4375,9.5 Z"
                    transform="translate(0 -.5)"
                />
            </g>
        </svg>
    );
};

export default React.memo(CartWarning);
